module.exports = __webpack_public_path__ + "img/pre-university-bootcamp.2bf819a0.png";